import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SelectEconomic from '../common/select-filters/SelectEconomic';
import EnforcementCapacityChart from '../common/charts/EnforcementCapacityChart';
import EnforcementCapacityNewChart from '../common/charts/EnforcementCapacityNewChart';
import MapSection from '../common/MapSection.js';
import Methodology from '../common/Methodology';
import Related from '../common/Related.js';

import { enforcementCapacityTabs } from '../../model/subMenuTabs';

import { setCountry1, setCountry2, setCountry3 } from '../../actions/';

const EnforcementCapacity = props => {

	const currentPath = '/osh-infrastructure/enforcement-capacity/';
	// Get global state for the selects
	const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
	const [countryLocked, setCountryLocked] = useState(lockedCountry);
	const [loaded, setLoaded] = useState(false);
	const [secondLevelTabs, setSecondLevelTabs] = useState(undefined);
	const [selectedTab, setSelectedTab] = useState(undefined);
	const [secondLevelSelectedTab, setSecondLevelSelectedTab] = useState(undefined);
	const [showSecondLevel, setShowSecondLevel] = useState(false);
	const [dataset, setDataset] = useState(props.dataset);
	const [filters, setFilters] = useState({
		countries: [
			{ code: props.country1 ? props.country1 : 'AT' },
			{ code: props.country2 ? props.country2 : '0' },
			{ code: props.country3 ? props.country3 : '0' }
		]
	})
	
	// Hook for the dispatchs
	const dispatch = useDispatch();

	useEffect(() => {
		if (props.country1 != undefined && props.country2 != undefined && props.country3 != undefined) {
			dispatch(setCountry1(props.country1));
			dispatch(setCountry2(props.country2));
			dispatch(setCountry3(props.country3));
		}

		// Update the title of the page
		document.title = props.literals.L22017 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		const selected = enforcementCapacityTabs.find((tab) => tab.url == props.dataset);
		if (selected)
		{
			setSelectedTab(selected);

			if (selected.subTabs != undefined)
			{
				setSecondLevelTabs(selected.subTabs);
				setShowSecondLevel(true);

				const secondLevelSelected = selected.subTabs.find((tab) => tab.url == props.indicator);
				setSecondLevelSelectedTab(secondLevelSelected);
			}
		}

		setLoaded(true);
	}, [])

	const handleSearch = (callbackCountry1) => {
		if (selectedByUser) {
			setCountryLocked(callbackCountry1);
		} else {
			dispatch(setCountry1(callbackCountry1));
		}
		setFilters({
			countries: [ { code: callbackCountry1 }, filters.countries[1], filters.countries[2] ]
		});
	}

	const handleSearch2 = (callbackCountry2) => {
		dispatch(setCountry2(callbackCountry2));
		setFilters({
			countries: [ filters.countries[0], { code: callbackCountry2 }, filters.countries[2] ]
		});
	}

	const handleSearch3 = (callbackCountry3) => {
		dispatch(setCountry3(callbackCountry3));
		setFilters({
			countries: [ filters.countries[0], filters.countries[1], { code: callbackCountry3 } ]
		});
	}

	const callbackSelectedTab = (callback) => {
		const selected = enforcementCapacityTabs.find((tab) => tab.url == callback);
		if (selected)
		{
			const showSecond = selected.subTabs != null && selected.subTabs.length > 0;
			setSelectedTab(selected);
			setSecondLevelTabs(selected.subTabs);
			setSecondLevelSelectedTab(showSecond ? selected.subTabs[0] : null);
			setDataset(callback);
			setShowSecondLevel(showSecond);
		}
	}

	const callbackSelectedIndicator = (callback) => {
		// This function will be called when changing the indicator on the current tab
		const secondLevelSelected = secondLevelTabs.find((tab) => tab.url == callback);
		if (secondLevelSelected)
		{
			setSecondLevelSelectedTab(secondLevelSelected);
		}
	}

	if (!loaded)
	{
		return null
	}

	let submenu = '';
	let tabContent = '';
	let noPaddingClass = '';
	let containerClass = '';

	let methodologyIndicator = '';

	const selectCountry1 = selectedByUser ? countryLocked : selectCountry;

	if (showSecondLevel)
	{
		methodologyIndicator = secondLevelSelectedTab.chartType[0].chartIndicator;
		containerClass='container';
		submenu = <SubMenuTabs 
			literals={ props.literals }
			selectedTab={ secondLevelSelectedTab.url }
			callbackSelectedTab={ callbackSelectedIndicator }
			locationPath={`${currentPath}${dataset}/`}
			subMenuTabs={ secondLevelTabs }
		/>
		
		tabContent = secondLevelTabs.map((element) => {
			if (selectedTab.url == 'inspector-activities'){
				if (element.url == secondLevelSelectedTab.url) {
					if (secondLevelSelectedTab.url == 'establishments-inspected') {
						return (
							<div className='container section--page card--grid xxs-w1 xs-w1 w1 center-text'>
								<div key={element.literalTab} className="card--block--chart less-padding">
									<div className="chart--block with-filter" >
										<div className="card--block--chart--wrapper" >
											<div className="chart--block">
												<EnforcementCapacityChart
													title={ props.literals[`L${element.chartType[0].title}`] }
													subtitle={ props.literals[`L${element.chartType[0].subTitle}`] }
													colors={ ['#f6a400','#f3c564', '#449fa2', '#cbe2e3', '#7b7b7d', '#B1B3B4'] }
													tick={ 20 }
													percentage={ true }
													type={ 'column' }
													selectCountry1={ selectCountry1 }
													selectCountry2={ selectCountry2 }
													selectCountry3={ selectCountry3 }
													chart={ element.chartType[0].chart }
													indicator={ element.chartType[0].chartIndicator }
													sector={ element.chartType[0].sector }
													answers={ element.chartType[0].answers }
													stackingColumn={ 'normal' }
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="chart-legend">
									{ ReactHtmlParser( props.literals[`L${secondLevelSelectedTab.chartType[0].legend}`] ) }
								</div>
							</div>
						)
					} else if ( secondLevelSelectedTab.url == 'share-enterprises-visited' ) {
						return (
							<div className='container section--page card--grid xxs-w1 xs-w1 w1 center-text'>
								<div key={element.literalTab} className="card--block--chart less-padding">
									<div className="chart--block with-filter" >
										<div className="card--block--chart--wrapper" >
											<div className="chart--block">
												<EnforcementCapacityNewChart
													width="450"
													literals={ props.literals }
													chartType={ secondLevelSelectedTab.chartType }
													decimalNumbers={ 1 }
													yAxisMax={ 100 }
													legend={ true }
												/>
											</div>
										</div>
									</div>									
								</div>
								<div className="chart-legend">
									{ ReactHtmlParser(props.literals[`L${secondLevelSelectedTab.chartType[0].legend}`]) }
								</div>
							</div>								
						)
					} else {
						return (
							<div className='container section--page card--grid xxs-w1 xs-w1 w1 center-text'>
								<div key={element.literalTab} className="card--block--chart less-padding">
									<div className="chart--block with-filter" >
										<div className="card--block--chart--wrapper" >
											<div className="chart--block">
												<EnforcementCapacityNewChart
													width="450"
													literals={ props.literals }
													chartType={ secondLevelSelectedTab.chartType }
													decimalNumbers={ 1 }
													legend={ false }
												/>
											</div>
										</div>
									</div>									
								</div>
								<div className="chart-legend">
									{ ReactHtmlParser(props.literals[`L${secondLevelSelectedTab.chartType[0].legend}`]) }
								</div>
							</div>
						)
					}
				}
			}
		})
	}
	else
	{
		noPaddingClass = 'nopadding';
		tabContent = <MapSection 
			literals = { props.literals }
			chartID = { selectedTab.mapChart }
			indicatorList = { selectedTab.mapIndicators }
			selectedIndicator = { selectedTab.mapIndicators[0] }
			showEUBanner = { true }
		/>
	}

	let selecteconomic 

	if (secondLevelSelectedTab && secondLevelSelectedTab.url == 'establishments-inspected') {
		selecteconomic = <SelectEconomic 
			handleSearch={ handleSearch }
			handleSearch2={ handleSearch2 }
			handleSearch3={ handleSearch3 }
			literals={ props.literals }
			selectedCountry1={ selectCountry1 }
			selectedCountry2={ selectCountry2 }
			selectedCountry3={ selectCountry3 }
		/>
	}

	return(
		<div className="country--profile--page enforcement-capacity">
			<AdviceSection literals={ props.literals } section={["osh-infrastructure","enforcement-capacity"]} methodologyData={{section: 'osh-infrastructure', subsection: 'Enforcement capacity', indicator: 285}} />

			<div className='top--submenu'>
				<SubMenuTabs 
					literals={ props.literals }
					selectedTab={ selectedTab.url }
					callbackSelectedTab={ callbackSelectedTab }
					locationPath={ currentPath }
					subMenuTabs={ enforcementCapacityTabs } 
					selectCountry1={ selectCountry1 }
					selectCountry2={ selectCountry2 }
					selectCountry3={ selectCountry3 }
				/>
			</div>

			{ submenu != '' && 
				<div className='second--submenu'>
					<div className="line background-main-light" />
					{ submenu }
				</div>
			}

			<div className="line background-main-light"></div>

			<React.Fragment>
				{ selecteconomic }
			</React.Fragment>

			<div className="line background-main-light"></div>

			<div className={`section--page card--grid xxs-w1 xs-w1 w1 ${containerClass} ${noPaddingClass}`}>
				{tabContent}
			</div>

			<Methodology literals={ props.literals } section={'Enforcement capacity'} subsection={ showSecondLevel != true ? 'sanctions-impact' : null} indicator={ methodologyIndicator } />
			{ ( secondLevelSelectedTab != null && secondLevelSelectedTab != "" ) && 
				<Related literals={ props.literals } section={ [ "osh-infrastructure","enforcement-capacity", secondLevelSelectedTab.url ] } country1={props.selectedByUser ? lockedCountry : props.selectCountry} country2={ props.selectCountry2 } country3={ props.selectCountry3 } />
			}
		</div>
	)
}
EnforcementCapacity.displayName = 'EnforcementCapacity';
export default EnforcementCapacity;